export default {"src":"/_next/static/media/impact-grid-vertical.eebc78d5.svg","height":1647,"width":1702,"blurWidth":0,"blurHeight":0};